module.exports = __webpack_public_path__ + "static/media/refurbishToilet.1bcfc063.jpg";